export default {
  env: 'staging',
  apiBaseURL: 'https://linkia.api.interficie.com/api',
};
